import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MasterService } from 'src/app/core/services/master.service';

export const wildcardRedirectGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const masterService = inject(MasterService);

  // Use route.routeConfig?.path to match the route
  if (route.routeConfig?.path === 'shared/complete-account-setup') {
    return true;
  }
  if (state.url.includes('/shared/reset-password')) {
    return true;
  }

  const user = masterService.getUserDetailFromStorage();
  const accessToken = getCookie('accessToken');

  if (user && accessToken) {
    const redirectPath = user.companyid == -1 ? '/admin-portal/admin-dashboard' : '/home';
    router.navigate([redirectPath]);
  } else {
    router.navigate(['/shared/login']);
  }

  return false;
};

function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}
